import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer";
import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin";
import { GalleryPlugin } from "@photo-sphere-viewer/gallery-plugin";
import { MapPlugin } from "@photo-sphere-viewer/map-plugin";
import "@photo-sphere-viewer/markers-plugin/index.css";
import "@photo-sphere-viewer/virtual-tour-plugin/index.css";
import "@photo-sphere-viewer/gallery-plugin/index.css";
import { useRef, useState } from "react";
import { renderToStaticMarkup } from 'react-dom/server';
import CustomPanelContent from "./Component/CustomPanelContent";
import CustomMarker from "./Component/CustomMarker";
import data2 from "./data2";

export default function CasaBallroomViewer () {

  const [currentPanorama, setCurrentPanorama] = useState('assets/HotelMerlynn_360_4k/B1_Tripodless.jpg');
  const currentPanoramaId = useRef();
	const pSRef = useRef();
  const pSRefCore = useRef();
  
  let markersPlugin = null;

  const renderPanelString = (data2) => {
    return data2.map(d =>
      renderToStaticMarkup(
        <CustomPanelContent
          id={d.id}
          url={d.url}
          file={d.file}
          img={d.img}
          longText={d.longText}
        />
      )
    )
  }

  const renderMarkerString = (data2) => {
    return data2.map(d =>
      renderToStaticMarkup(
        <CustomMarker
          id={d.id}
          icon={d.icon}
          img={d.img}
          name={d.name}
          type={d.type}
        />
      )
    )
  }
  
  const infoMarkerStringArr = renderMarkerString(data2.infoMarkersData)
  const roomMarkerStringArr = renderMarkerString(data2.roomMarkersData)
  const panelContentStringArr = renderPanelString(data2.panelContentsData)

  const togglePanel = (id, panelContent) => {
    if (pSRefCore.current.panel.isVisible(id)) {
      pSRefCore.current.panel.hide();
    } else {
      pSRefCore.current.panel.show({
        id: id,
        width: '25%',
        content: panelContent,
      });
    }
  }

  const handleReady = (instance) => {
    pSRefCore.current = instance;
    const viewer = pSRef.current

		// initialize plugins 
		markersPlugin = instance.getPlugin(MarkersPlugin);
    const galleryPlugin = instance.getPlugin(GalleryPlugin);
    const mapPlugin = instance.getPlugin(MapPlugin);

    if (!markersPlugin) return;

    // map plugin
    // mapPlugin.addEventListener('select-hotspot', ({ hotspotId }) => {
    //   let id = hotspotId + "-marker"

    //   let roomMap = data2.roomMarkerMapData.find(item => item.id === id)

    //   currentPanoramaId.current = id
    //   setCurrentPanorama(roomMap.panorama)
    //   viewer.setPanorama(roomMap.panorama)
    // });

    // gallery plugin
    galleryPlugin.setItems(data2.galleryData)
    pSRefCore.current.addEventListener('panorama-load', (panorama) => {

      let roomMap = data2.roomMarkerMapData.find(item => item.panorama == panorama.panorama)

      // let hotspot = roomMap.id.replace("-marker", "");
      // let newHotspotCenter = data2.mapData[0].hotspots.find(item => item.id === hotspot)
      // mapPlugin.setOptions({
      //   center: {
      //     x: newHotspotCenter.x,
      //     y: newHotspotCenter.y
      //   }
      // })

      markersPlugin.clearMarkers()
      let markers = roomMap.markers.map(item => {
        let pairData = null
        let pairArr = null 

        if(item.data.type == "info"){
          pairData = data2.infoMarkersData
          pairArr = infoMarkerStringArr
        }
        else if (item.data.type == "room"){
          pairData = data2.roomMarkersData
          pairArr = roomMarkerStringArr
        }
        let pairIndex = pairData.findIndex(pair => pair.id == item.html)
        return {
          ...item,
          html: pairArr[pairIndex] 
        }
      })
      markers.forEach(marker => markersPlugin.addMarker(marker));
    })

    markersPlugin.addEventListener("select-marker", (e) => {
      const id = e.marker.config.id
      const type = e.marker.config.data.type

      if (type == "info") {
        // cari di panelContent.marker yg sama dg id
        // id -> dining-area-info
        // panelContent.marker -> dining-area-info-marker
        if(infoMarkerStringArr.find(item => item.id === data2.infoMarkersData.id)) {
          let panelContentIdx = data2.panelContentsData.findIndex(item => item.marker === id)
          togglePanel(id, panelContentStringArr[panelContentIdx]);
        }
      }

      if (type == "room") {
        let roomMap = data2.roomMarkerMapData.find(item => item.id === id)
        currentPanoramaId.current = id
        setCurrentPanorama(roomMap.panorama)
        viewer.setPanorama(roomMap.panorama)
      }
    });

  
  };

  const markersInit = data2.roomMarkerMapData[0].markers.map(item => {
    let pairData = null
    let pairArr = null 
    if(item.data.type == "info"){
      pairData = data2.infoMarkersData
      pairArr = infoMarkerStringArr
    }
    else if (item.data.type == "room"){
      pairData = data2.roomMarkersData
      pairArr = roomMarkerStringArr
    }
    
    let pairIndex = pairData.findIndex(pair => pair.id == item.html)

    return {
      ...item,
      html: pairArr[pairIndex] 
    }
  })



	// declare plugins
  const plugins = [
    [
			MarkersPlugin, 
			{
        markers: markersInit 
			}
		],
    [
      GalleryPlugin,
    ],
    // [
    //   MapPlugin,
    //   data2.mapData[0]
    // ]
  ];


  return (
    <div className="App" id={"container-360"}>
      <ReactPhotoSphereViewer
        ref={pSRef}
        loadingImg= {"assets/loading.gif"}
        name=""
        defaultYaw={"0deg"}
        navbar={[
          "zoom",
          "move",
          "gallery",
          // "download",
          // "caption",
          "fullscreen",
        ]}
        height={"100vh"}
        width={"100%"}
        hideNavbarButton={false}
        onReady={(instance) => {
          handleReady(instance)
        }}
        defaultZoomLvl="0"
        plugins={plugins}
        container={"container-360"}
        src={currentPanorama}
      ></ReactPhotoSphereViewer>
    </div>
  );
}
